import type { BannerRatio } from '@proptr/creative-templates';
import type { SelectOption } from '../components/ui/select.js';

// The creative templates, shared by the feed builder and the post builder.
//
// One list because the two builders offer the same choice — a template the
// feed can render but the post can't (or vice versa) is a bug, and two
// literals is how that happens. The stored values are the same strings the
// API and the /render route already resolve.

export const TEMPLATE_BANNER = 'listing-banner';
export const TEMPLATE_LOOKBOOK = 'listing-lookbook';

export const TEMPLATE_OPTIONS: SelectOption<string>[] = [
  { value: TEMPLATE_BANNER, label: 'Listing banner' },
  { value: TEMPLATE_LOOKBOOK, label: 'Listing lookbook' },
];

/**
 * Whether a template can render a given canvas.
 *
 * The lookbook is square-only — its vertical is specified in the design
 * handoff but not built. Callers must gate on this rather than assume,
 * because the alternative is a story placement that silently renders a
 * square and ships wrong.
 */
export function templateSupportsRatio(
  template: string,
  ratio: BannerRatio,
): boolean {
  if (ratio === '1:1') return true;
  return template !== TEMPLATE_LOOKBOOK;
}
